import React, { useState } from 'react';
import { TrendingUp, TrendingDown, Activity, RefreshCw } from 'lucide-react';

// Import the new components
import StatCard from '../components/StatCard';
import MoversTable from '../components/MoversTable';

// Import the new dashboard-specific CSS
import '../Dashboard.css';

// Mock data that mimics our API structure
const mockStats = {
  top_gainer: { label: 'WEGE3', value: 4.12 },
  top_loser: { label: 'MGLU3', value: -5.89 },
  most_active: { label: 'PETR4', value: '1.2B' },
};

const mockMovers = [
  { type: 'gainer', ticker: 'WEGE3', company: 'WEG S.A.', last: 42.56, change: 4.12, volume: '250M' },
  { type: 'gainer', ticker: 'B3SA3', company: 'B3 S.A. - Brasil, Bolsa, Balcão', last: 11.23, change: 3.20, volume: '400M' },
  { type: 'gainer', ticker: 'SUZB3', company: 'Suzano S.A.', last: 41.22, change: 3.10, volume: '180M' },
  { type: 'gainer', ticker: 'PETR4', company: 'Petróleo Brasileiro S.A. - Petrobras', last: 38.42, change: 2.30, volume: '1.2B' },
  { type: 'loser', ticker: 'RENT3', company: 'Localiza Rent a Car S.A.', last: 45.67, change: -2.20, volume: '150M' },
  { type: 'loser', ticker: 'ABEV3', company: 'Ambev S.A.', last: 12.34, change: -0.30, volume: '300M' },
  { type: 'loser', ticker: 'VALE3', company: 'Vale S.A.', last: 64.89, change: -1.10, volume: '800M' },
  { type: 'loser', ticker: 'MGLU3', company: 'Magazine Luiza S.A.', last: 2.87, change: -5.89, volume: '600M' },
];


function DashboardPage() {
  const [view, setView] = useState('movers');
  const [metric, setMetric] = useState('VAR');

  const handleRefresh = () => {
    //console.log("Refreshing data...");
    // Later, this will trigger an API call
  };

  return (
    <div className="dashboard-container">
      {/* Silk Background from HomePage can be added here if desired */}
      {/* <div className="silk-background"> ... </div> */}

      <header className="dashboard-header">
        <div>
          <h1>Dashboard de Análise</h1>
          <p>Dados do mercado em tempo real</p>
        </div>
        <div className="controls-panel">
          <select value={view} onChange={(e) => setView(e.target.value)}>
            <option value="movers">📊 Top Movers</option>
            <option value="all">📈 Todas Ações</option>
            <option value="volume">🔥 Mais Ativas</option>
          </select>
          <select value={metric} onChange={(e) => setMetric(e.target.value)}>
            <option value="VAR">Diário</option>
            <option value="SEM">Semanal</option>
            <option value="MES">Mensal</option>
          </select>
          <button onClick={handleRefresh}>
            <RefreshCw size={16} />
          </button>
        </div>
      </header>

      <main>
        <section className="stats-grid">
          <StatCard 
            icon={<TrendingUp size={20} className="value-green"/>}
            title="Maior Alta"
            ticker={mockStats.top_gainer.label}
            value={`+${mockStats.top_gainer.value.toFixed(2)}%`}
            valueColor="value-green"
          />
          <StatCard 
            icon={<TrendingDown size={20} className="value-red"/>}
            title="Maior Baixa"
            ticker={mockStats.top_loser.label}
            value={`${mockStats.top_loser.value.toFixed(2)}%`}
            valueColor="value-red"
          />
          <StatCard 
            icon={<Activity size={20} className="value-gold"/>}
            title="Mais Ativa (Volume)"
            ticker={mockStats.most_active.label}
            value={mockStats.most_active.value}
            valueColor="value-gold"
          />
        </section>

        <section>
          {view === 'movers' && <MoversTable data={mockMovers} />}
          {/* Add placeholders for other views */}
          {view !== 'movers' && (
            <div className="main-content-wrapper" style={{textAlign: 'center', padding: '4rem'}}>
              <p>Visualização para '{view}' ainda não implementada.</p>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

export default DashboardPage;